/* pi-localization.js — Aurora locale dropdowns in pi-header ============= */
(function () {
  function patchLocalizationForm() {
    const Klass = customElements.get('localization-form');
    if (!Klass || Klass.prototype.__piPatched) return !!Klass;

    const originalOpen = Klass.prototype.openSelector;
    const originalHide = Klass.prototype.hidePanel;

    Klass.prototype.openSelector = function () {
      if (!this.closest('.pi-header__locale-group, .pi-footer__locale-group')) {
        return originalOpen.call(this);
      }

      document
        .querySelectorAll(
          '.pi-header__locale-group .pi-locale-disclosure__button[aria-expanded="true"], .pi-footer__locale-group .pi-locale-disclosure__button[aria-expanded="true"]'
        )
        .forEach((btn) => {
          if (btn !== this.elements.button) {
            btn.setAttribute('aria-expanded', 'false');
            const panel = btn
              .closest('localization-form')
              ?.querySelector('.disclosure__list-wrapper');
            if (panel) panel.setAttribute('hidden', true);
          }
        });

      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        String(this.elements.button.getAttribute('aria-expanded') === 'false')
      );

      if (this.elements.search && this.mql && this.mql.matches) {
        this.elements.search.focus();
      }

      const header = document.querySelector('.pi-header-wrapper.header-wrapper, .header-wrapper');
      if (header && this.hasAttribute('data-prevent-hide')) {
        header.preventHide = true;
      }
    };

    Klass.prototype.hidePanel = function () {
      if (!this.closest('.pi-header__locale-group, .pi-footer__locale-group')) {
        return originalHide.call(this);
      }

      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.elements.search) {
        this.elements.search.value = '';
        if (typeof this.filterCountries === 'function') this.filterCountries();
      }

      const header = document.querySelector('.pi-header-wrapper.header-wrapper, .header-wrapper');
      if (header) header.preventHide = false;
    };

    Klass.prototype.__piPatched = true;
    return true;
  }

  function waitForLocalization() {
    if (patchLocalizationForm()) return;
    requestAnimationFrame(waitForLocalization);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForLocalization);
  } else {
    waitForLocalization();
  }
})();
